"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertOperationToDescriptor = void 0;
// TODO: we need to delete this file when this function will be not used.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function convertOperationToDescriptor(operation) {
    return {
        name: operation.name,
        method: operation.method.toLowerCase(),
        bodyParamNames: operation.bodyParamNames || [],
        urlPattern: operation.urlPathPattern,
        urlPatternParamNames: operation.urlPathParamNames,
    };
}
exports.convertOperationToDescriptor = convertOperationToDescriptor;
//# sourceMappingURL=DescriptorConverter.js.map